import React, { useState, useEffect } from "react";
import axios from "axios";
import { serverUrl } from '../../Constant/Static/config';
import Loader from "../../Constant/Custom/Loader";
const StatsTable = () => {
  const [error, setError] = useState(null);
  const [reloadFlag, setReloadFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [datetime, setDateTime] = useState('')
  const [statsData, setStatsData] = useState([
    { sno: 1, info: "Total Number of the Registrations", count: 0 },
    { sno: 2, info: "Total Number of Applicants started filling", count: 0 },
    { sno: 3, info: "Applications Completed(OTHERS)", count: 0 },
    { sno: 4, info: "Applications Completed(SC/ST/SCA)", count: 0 },
    { sno: 5, info: "Paid and Not Submitted", count: 0 },
    { sno: 6, info: "Special Category", count: 0 },
    { sno: 7, info: "Diploma Candidates", count: 0 },
    { sno: 8, info: "B.Sc Candidates", count: 0 },
    { sno: 9, info: "Sports Category", count: 0 },
    { sno: 10, info: "EX-Serviceman", count: 0 },
    { sno: 11, info: "Differently Abled", count: 0 },
    { sno: 12, info: "OC Candidates", count: 0 },
    { sno: 13, info: "BCM Candidates", count: 0 },
    { sno: 14, info: "BC Candidates", count: 0 },
    { sno: 15, info: "MBC Candidates", count: 0 },
    { sno: 16, info: "SC Candidates", count: 0 },
    { sno: 17, info: "SCA Candidates", count: 0 },
    { sno: 18, info: "ST Candidates", count: 0 },
    { sno: 19, info: "Diploma Regular", count: 0 },
    { sno: 20, info: "Diploma Lateral", count: 0 },
    { sno: 21, info: "Diploma Sandwich", count: 0 },
    { sno: 22, info: "Diploma Parttime", count: 0 },
    { sno: 23, info: "Payment Completed Others", count: 0 },
    { sno: 24, info: "Payment Completed(SC/ST/SCA)", count: 0 },
    { sno: 25, info: "Total Payment Successful", count: 0 },

  ]);
  const [csrfToken, setCsrfToken] = useState('');
  const [load, setload] = useState(false)
  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true
        });
        setCsrfToken(response.data.csrfToken);
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);
  const handleReload = () => {
    setReloadFlag(true);


  }
  useEffect(() => {
    if (!reloadFlag) return; 

    const fetchCounts = async () => {
    
      setError(null); 

      try {
          setLoading(true);
        const payload = { snos: statsData.map((row) => row.sno) };

        const response = await axios.post(
          `${serverUrl}/api/admin/statscount`,
          payload, 
          {
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken, 
            },
            withCredentials: true, 
          }
        );

        const data = response.data;

        const updatedStats = [
          { sno: 1, info: "Total Number of the Registrations", count: data.totalRegistration || 0 },
          { sno: 2, info: "Total Number of Applicants started filling", count: data.totalStudents || 0 },
          { sno: 3, info: "Applications Completed(OTHERS)", count: data.submittedothercom || 0 },
          { sno: 4, info: "Applications Completed(SC/ST/SCA)", count: data.submittedscscast || 0 },
          { sno: 5, info: "Paid and Not Submitted", count: data.paidNotSubmitted },
          { sno: 6, info: "Special Category", count: data.splReserve || 0 },
          { sno: 7, info: "Diploma Candidates", count: data.diplomo || 0 },
          { sno: 8, info: "B.Sc Candidates", count: data.bsc || 0 },
          { sno: 9, info: "Sports Category", count: data.sports || 0 },
          { sno: 10, info: "EX-Serviceman", count: data.exserviceman || 0 },
          { sno: 11, info: "Differently Abled", count: data.differentlyabled || 0 },
          { sno: 12, info: "OC Candidates", count: data.OC || 0 },
          { sno: 13, info: "BCM Candidates", count: data.BCM || 0 },
          { sno: 14, info: "BC Candidates", count: data.BC || 0 },
          { sno: 15, info: "MBC Candidates", count: data.MBC || 0 },
          { sno: 16, info: "SC Candidates", count: data.SC || 0 },
          { sno: 17, info: "SCA Candidates", count: data.SCA || 0 },
          { sno: 18, info: "ST Candidates", count: data.ST || 0 },
          { sno: 19, info: "Diploma Regular", count: data.regular || 0 },
          { sno: 20, info: "Diploma Lateral", count: data.lateral || 0 },
          { sno: 21, info: "Diploma Sandwich", count: data.sandwich || 0 },
          { sno: 22, info: "Diploma Parttime", count: data.Parttime || 0 },
          { sno: 23, info: "Payment Completed Others", count: data.otherspaymentsucess || 0 },
          { sno: 24, info: "Payment Completed(SC/ST/SCA)", count: data.scscastpayment || 0 },
          { sno: 25, info: "Total Payment Successful", count: data.paymentSuccess || 0 },
        ];

        setStatsData(updatedStats);

        // Update datetime
        const date = new Date();
        const currDate = date.toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
        });
        setDateTime(currDate);
      } catch (error) {
        console.error("Error fetching counts:", error.message);
        setError('Failed to fetch statistics. Please try again.');
      } finally {
        setLoading(false);
        setReloadFlag(false); 
      }
    };

    fetchCounts();
  }, [reloadFlag, csrfToken]);
  if(loading){
    return (
      <Loader/>
    )
  }

  const styles = {
    pageContainer: {
      padding: "20px",
      margin: "20px",
      fontFamily: "Arial, sans-serif",
      backgroundColor: "#f9f9f9",
      borderRadius: "8px",
      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      overflowX: "auto"
    },
    title: {
      fontSize: "1.5rem",
      marginBottom: "20px",
      textAlign: "center",
      color: "#333"
    },
    loadbutton: {
      padding: "6px 17px",
      fontSize: "1rem",
      backgroundColor: "#36A2EB",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      marginBottom: "10px"

    },
    table: {
      fontSize: "15px",
      marginBottom: "10px",
      width: "100%",
      maxWidth: "800px", 
      overflowX: "scroll",
      borderCollapse: "collapse",
      backgroundColor: "#fff",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      marginLeft: "auto",   
      marginRight: "auto"   
    },
    th: {
      padding: "12px 15px",
      backgroundColor: "#f4f4f9",
      fontWeight: "bold",
      textAlign: "center",
      border: "2px solid #ddd"
    },
    td: {
      padding: "12px 15px",
      textAlign: "left",
      border: "1px solid #ddd",
      textAlign: "center"
    },
    rowEven: {
      backgroundColor: "#ffffff"
    },
    rowOdd: {
      backgroundColor: "#f9f9f9"
    },
    buttonHeader: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"

    },
    date: {
      
      marginRight: "30px"
    },
    datecontainer: {
      display: "flex"
    },
    datename: {
      fontSize: "1.5rem",
      marginBottom: "20px",
      textAlign: "center",
      marginTop: "30px",
       color: "#333"

    }
  };


  return (
    <div style={styles.pageContainer}>
      <div >
        <h2 style={styles.title}>Application Statistics</h2>

      </div>

    

      <div style={styles.buttonHeader}>
        <button style={styles.loadbutton} onClick={handleReload}>Load Details</button>

      </div>
      <div style={styles.buttonHeader}>
        <span style={styles.datename} >Date:</span>
        <h2 style={styles.date}>{datetime}</h2>

      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>S.No.</th>
            <th style={styles.th}>Info</th>
            <th style={styles.th}>Count</th>
          </tr>
        </thead>
        <tbody>
          {statsData.map((row, index) => (
            <tr
              key={row.sno}
              style={index % 2 === 0 ? styles.rowEven : styles.rowOdd}
            >
              <td style={styles.td}>{row.sno}</td>
              <td style={styles.td}>{row.info}</td>
              <td style={styles.td}>{row.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StatsTable;